import {
  Companion_getInstance23ulzawec7mjy as Companion_getInstance,
  ModelPermissions2241fbc4jxkyq as ModelPermissions,
} from './ModelPermissions.mjs';
import { NothingSerializer3oixyyf77l4xt as NothingSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../serialization/SerializableProperty.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  Never_getInstance32s86skpi7zck as Never_getInstance,
  Conditionuclxcm24fzd9 as Condition,
} from './Condition.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Mask3fc1c3tjgnucb as Mask } from './Mask.mjs';
import { UpdateRestrictions6ebv9x6ps9p5 as UpdateRestrictions } from './UpdateRestrictions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareModelPermissionsFields() {
  var tmp = Companion_getInstance().q2j(NothingSerializer());
  properties(tmp, prepareModelPermissionsFields$lambda);
}
function ModelPermissions_create$name$delegate$lambda() {
  return Companion_getInstance().q2j(NothingSerializer()).az().v11(0);
}
function ModelPermissions_create$_get_name_$ref_apm2pf() {
  return (p0) => p0.i20();
}
function ModelPermissions_create$_get_serializer_$ref_6fabpo() {
  return (p0) => p0.h2j();
}
function ModelPermissions_create$_get_annotations_$ref_u155c8() {
  return (p0) => p0.bz();
}
var ModelPermissions_createClass;
function ModelPermissions_create() {
  if (ModelPermissions_createClass === VOID) {
    class $ {
      constructor(model) {
        var tmp = this;
        tmp.r2j_1 = lazy(ModelPermissions_create$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s2j_1 = lazy(() => {
          var tmp = Companion_getInstance().q2j(model);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.t2j_1 = lazy(() => Companion_getInstance().q2j(model).az().x11(0));
        this.u2j_1 = Never_getInstance();
        this.v2j_1 = 'Condition.Never';
      }
      i20() {
        var tmp0 = this.r2j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ModelPermissions_create$_get_name_$ref_apm2pf(), null);
        return tmp0.f2();
      }
      w2j(receiver) {
        return receiver.x2j_1;
      }
      k2j(receiver) {
        return this.w2j(receiver instanceof ModelPermissions() ? receiver : THROW_CCE());
      }
      e2k(receiver, value) {
        return receiver.f2k(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ModelPermissions() ? receiver : THROW_CCE();
        return this.e2k(tmp, value instanceof Condition() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.s2j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ModelPermissions_create$_get_serializer_$ref_6fabpo(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t2j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ModelPermissions_create$_get_annotations_$ref_u155c8(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 1184104511;
      }
      equals(other) {
        return other instanceof ModelPermissions_create();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'ModelPermissions_create', VOID, VOID, [SerializableProperty()]);
    ModelPermissions_createClass = $;
  }
  return ModelPermissions_createClass;
}
function ModelPermissions_read$name$delegate$lambda() {
  return Companion_getInstance().q2j(NothingSerializer()).az().v11(1);
}
function ModelPermissions_read$_get_name_$ref_1c0h95() {
  return (p0) => p0.i20();
}
function ModelPermissions_read$_get_serializer_$ref_zgekj6() {
  return (p0) => p0.h2j();
}
function ModelPermissions_read$_get_annotations_$ref_hk5scy() {
  return (p0) => p0.bz();
}
var ModelPermissions_readClass;
function ModelPermissions_read() {
  if (ModelPermissions_readClass === VOID) {
    class $ {
      constructor(model) {
        var tmp = this;
        tmp.g2k_1 = lazy(ModelPermissions_read$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h2k_1 = lazy(() => {
          var tmp = Companion_getInstance().q2j(model);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.i2k_1 = lazy(() => Companion_getInstance().q2j(model).az().x11(1));
        this.j2k_1 = Never_getInstance();
        this.k2k_1 = 'Condition.Never';
      }
      i20() {
        var tmp0 = this.g2k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ModelPermissions_read$_get_name_$ref_1c0h95(), null);
        return tmp0.f2();
      }
      w2j(receiver) {
        return receiver.y2j_1;
      }
      k2j(receiver) {
        return this.w2j(receiver instanceof ModelPermissions() ? receiver : THROW_CCE());
      }
      e2k(receiver, value) {
        return receiver.f2k(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ModelPermissions() ? receiver : THROW_CCE();
        return this.e2k(tmp, value instanceof Condition() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.h2k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ModelPermissions_read$_get_serializer_$ref_zgekj6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i2k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ModelPermissions_read$_get_annotations_$ref_hk5scy(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 263936741;
      }
      equals(other) {
        return other instanceof ModelPermissions_read();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'ModelPermissions_read', VOID, VOID, [SerializableProperty()]);
    ModelPermissions_readClass = $;
  }
  return ModelPermissions_readClass;
}
function ModelPermissions_readMask$name$delegate$lambda() {
  return Companion_getInstance().q2j(NothingSerializer()).az().v11(2);
}
function ModelPermissions_readMask$_get_name_$ref_lrx0kz() {
  return (p0) => p0.i20();
}
function ModelPermissions_readMask$_get_serializer_$ref_u0suu2() {
  return (p0) => p0.h2j();
}
function ModelPermissions_readMask$_get_annotations_$ref_ne2wpu() {
  return (p0) => p0.bz();
}
var ModelPermissions_readMaskClass;
function ModelPermissions_readMask() {
  if (ModelPermissions_readMaskClass === VOID) {
    class $ {
      constructor(model) {
        var tmp = this;
        tmp.l2k_1 = lazy(ModelPermissions_readMask$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m2k_1 = lazy(() => {
          var tmp = Companion_getInstance().q2j(model);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.n2k_1 = lazy(() => Companion_getInstance().q2j(model).az().x11(2));
        var tmp_2 = this;
        // Inline function 'kotlin.collections.listOf' call
        var tmp$ret$0 = emptyList();
        tmp_2.o2k_1 = new (Mask())(tmp$ret$0);
        this.p2k_1 = 'Mask(listOf())';
      }
      i20() {
        var tmp0 = this.l2k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ModelPermissions_readMask$_get_name_$ref_lrx0kz(), null);
        return tmp0.f2();
      }
      w2j(receiver) {
        return receiver.z2j_1;
      }
      k2j(receiver) {
        return this.w2j(receiver instanceof ModelPermissions() ? receiver : THROW_CCE());
      }
      q2k(receiver, value) {
        return receiver.f2k(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ModelPermissions() ? receiver : THROW_CCE();
        return this.q2k(tmp, value instanceof Mask() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m2k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ModelPermissions_readMask$_get_serializer_$ref_u0suu2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n2k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ModelPermissions_readMask$_get_annotations_$ref_ne2wpu(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -975070119;
      }
      equals(other) {
        return other instanceof ModelPermissions_readMask();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'ModelPermissions_readMask', VOID, VOID, [SerializableProperty()]);
    ModelPermissions_readMaskClass = $;
  }
  return ModelPermissions_readMaskClass;
}
function ModelPermissions_update$name$delegate$lambda() {
  return Companion_getInstance().q2j(NothingSerializer()).az().v11(3);
}
function ModelPermissions_update$_get_name_$ref_u32qbq() {
  return (p0) => p0.i20();
}
function ModelPermissions_update$_get_serializer_$ref_t54t0h() {
  return (p0) => p0.h2j();
}
function ModelPermissions_update$_get_annotations_$ref_3vmnr9() {
  return (p0) => p0.bz();
}
var ModelPermissions_updateClass;
function ModelPermissions_update() {
  if (ModelPermissions_updateClass === VOID) {
    class $ {
      constructor(model) {
        var tmp = this;
        tmp.r2k_1 = lazy(ModelPermissions_update$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s2k_1 = lazy(() => {
          var tmp = Companion_getInstance().q2j(model);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.t2k_1 = lazy(() => Companion_getInstance().q2j(model).az().x11(3));
        this.u2k_1 = Never_getInstance();
        this.v2k_1 = 'Condition.Never';
      }
      i20() {
        var tmp0 = this.r2k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ModelPermissions_update$_get_name_$ref_u32qbq(), null);
        return tmp0.f2();
      }
      w2j(receiver) {
        return receiver.a2k_1;
      }
      k2j(receiver) {
        return this.w2j(receiver instanceof ModelPermissions() ? receiver : THROW_CCE());
      }
      e2k(receiver, value) {
        return receiver.f2k(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ModelPermissions() ? receiver : THROW_CCE();
        return this.e2k(tmp, value instanceof Condition() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.s2k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ModelPermissions_update$_get_serializer_$ref_t54t0h(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t2k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ModelPermissions_update$_get_annotations_$ref_3vmnr9(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -78880238;
      }
      equals(other) {
        return other instanceof ModelPermissions_update();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'ModelPermissions_update', VOID, VOID, [SerializableProperty()]);
    ModelPermissions_updateClass = $;
  }
  return ModelPermissions_updateClass;
}
function ModelPermissions_updateRestrictions$name$delegate$lambda() {
  return Companion_getInstance().q2j(NothingSerializer()).az().v11(4);
}
function ModelPermissions_updateRestrictions$_get_name_$ref_knmk9r() {
  return (p0) => p0.i20();
}
function ModelPermissions_updateRestrictions$_get_serializer_$ref_cfyloo() {
  return (p0) => p0.h2j();
}
function ModelPermissions_updateRestrictions$_get_annotations_$ref_oc6l3g() {
  return (p0) => p0.bz();
}
var ModelPermissions_updateRestrictionsClass;
function ModelPermissions_updateRestrictions() {
  if (ModelPermissions_updateRestrictionsClass === VOID) {
    class $ {
      constructor(model) {
        var tmp = this;
        tmp.w2k_1 = lazy(ModelPermissions_updateRestrictions$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x2k_1 = lazy(() => {
          var tmp = Companion_getInstance().q2j(model);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.y2k_1 = lazy(() => Companion_getInstance().q2j(model).az().x11(4));
        var tmp_2 = this;
        // Inline function 'kotlin.collections.listOf' call
        var tmp$ret$0 = emptyList();
        tmp_2.z2k_1 = new (UpdateRestrictions())(tmp$ret$0);
        this.a2l_1 = 'UpdateRestrictions(listOf())';
      }
      i20() {
        var tmp0 = this.w2k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ModelPermissions_updateRestrictions$_get_name_$ref_knmk9r(), null);
        return tmp0.f2();
      }
      w2j(receiver) {
        return receiver.b2k_1;
      }
      k2j(receiver) {
        return this.w2j(receiver instanceof ModelPermissions() ? receiver : THROW_CCE());
      }
      b2l(receiver, value) {
        return receiver.f2k(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ModelPermissions() ? receiver : THROW_CCE();
        return this.b2l(tmp, value instanceof UpdateRestrictions() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.x2k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ModelPermissions_updateRestrictions$_get_serializer_$ref_cfyloo(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y2k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ModelPermissions_updateRestrictions$_get_annotations_$ref_oc6l3g(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -1134483925;
      }
      equals(other) {
        return other instanceof ModelPermissions_updateRestrictions();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'ModelPermissions_updateRestrictions', VOID, VOID, [SerializableProperty()]);
    ModelPermissions_updateRestrictionsClass = $;
  }
  return ModelPermissions_updateRestrictionsClass;
}
function ModelPermissions_delete$name$delegate$lambda() {
  return Companion_getInstance().q2j(NothingSerializer()).az().v11(5);
}
function ModelPermissions_delete$_get_name_$ref_9eu9wk() {
  return (p0) => p0.i20();
}
function ModelPermissions_delete$_get_serializer_$ref_g5jdkz() {
  return (p0) => p0.h2j();
}
function ModelPermissions_delete$_get_annotations_$ref_jnldqx() {
  return (p0) => p0.bz();
}
var ModelPermissions_deleteClass;
function ModelPermissions_delete() {
  if (ModelPermissions_deleteClass === VOID) {
    class $ {
      constructor(model) {
        var tmp = this;
        tmp.c2l_1 = lazy(ModelPermissions_delete$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d2l_1 = lazy(() => {
          var tmp = Companion_getInstance().q2j(model);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.e2l_1 = lazy(() => Companion_getInstance().q2j(model).az().x11(5));
        this.f2l_1 = Never_getInstance();
        this.g2l_1 = 'Condition.Never';
      }
      i20() {
        var tmp0 = this.c2l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ModelPermissions_delete$_get_name_$ref_9eu9wk(), null);
        return tmp0.f2();
      }
      w2j(receiver) {
        return receiver.c2k_1;
      }
      k2j(receiver) {
        return this.w2j(receiver instanceof ModelPermissions() ? receiver : THROW_CCE());
      }
      e2k(receiver, value) {
        return receiver.f2k(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ModelPermissions() ? receiver : THROW_CCE();
        return this.e2k(tmp, value instanceof Condition() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d2l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ModelPermissions_delete$_get_serializer_$ref_g5jdkz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e2l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ModelPermissions_delete$_get_annotations_$ref_jnldqx(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 1706013040;
      }
      equals(other) {
        return other instanceof ModelPermissions_delete();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'ModelPermissions_delete', VOID, VOID, [SerializableProperty()]);
    ModelPermissions_deleteClass = $;
  }
  return ModelPermissions_deleteClass;
}
function ModelPermissions_maxQueryTimeMs$name$delegate$lambda() {
  return Companion_getInstance().q2j(NothingSerializer()).az().v11(6);
}
function ModelPermissions_maxQueryTimeMs$_get_name_$ref_3q6uzs() {
  return (p0) => p0.i20();
}
function ModelPermissions_maxQueryTimeMs$_get_serializer_$ref_wei6j3() {
  return (p0) => p0.h2j();
}
function ModelPermissions_maxQueryTimeMs$_get_annotations_$ref_q5rxal() {
  return (p0) => p0.bz();
}
var ModelPermissions_maxQueryTimeMsClass;
function ModelPermissions_maxQueryTimeMs() {
  if (ModelPermissions_maxQueryTimeMsClass === VOID) {
    class $ {
      constructor(model) {
        var tmp = this;
        tmp.h2l_1 = lazy(ModelPermissions_maxQueryTimeMs$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i2l_1 = lazy(() => {
          var tmp = Companion_getInstance().q2j(model);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.j2l_1 = lazy(() => Companion_getInstance().q2j(model).az().x11(6));
        this.k2l_1 = 1000n;
        this.l2l_1 = '1_000L';
      }
      i20() {
        var tmp0 = this.h2l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ModelPermissions_maxQueryTimeMs$_get_name_$ref_3q6uzs(), null);
        return tmp0.f2();
      }
      w2j(receiver) {
        return receiver.d2k_1;
      }
      k2j(receiver) {
        return this.w2j(receiver instanceof ModelPermissions() ? receiver : THROW_CCE());
      }
      m2l(receiver, value) {
        return receiver.f2k(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ModelPermissions() ? receiver : THROW_CCE();
        return this.m2l(tmp, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.i2l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ModelPermissions_maxQueryTimeMs$_get_serializer_$ref_wei6j3(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j2l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ModelPermissions_maxQueryTimeMs$_get_annotations_$ref_q5rxal(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -1079386012;
      }
      equals(other) {
        return other instanceof ModelPermissions_maxQueryTimeMs();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'ModelPermissions_maxQueryTimeMs', VOID, VOID, [SerializableProperty()]);
    ModelPermissions_maxQueryTimeMsClass = $;
  }
  return ModelPermissions_maxQueryTimeMsClass;
}
function prepareModelPermissionsFields$lambda(args) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [new (ModelPermissions_create())(args[0]), new (ModelPermissions_read())(args[0]), new (ModelPermissions_readMask())(args[0]), new (ModelPermissions_update())(args[0]), new (ModelPermissions_updateRestrictions())(args[0]), new (ModelPermissions_delete())(args[0]), new (ModelPermissions_maxQueryTimeMs())(args[0])];
}
//region block: exports
export {
  prepareModelPermissionsFields as prepareModelPermissionsFields15lzayqlczylt,
};
//endregion

//# sourceMappingURL=ModelPermissionsFields.mjs.map
